module.exports = __webpack_public_path__ + "media/src/assets/girl-243817222fdd3562901e6e891e86776a.png";